module.exports = __webpack_public_path__ + "img/chaBing1.7a154146.png";